(function () {
  'use strict';

  // ── BFCACHE SETUP ──
  (function setupBfcache() {
    if (window._tdBfcacheReady) return;
    window._tdBfcacheReady = true;

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        setTimeout(function () {
          document.querySelectorAll('.image-cont[data-has-video="true"]').forEach(function (cont) {
            cont._videoAttached = false;
            cont._playing = false;
            cont._buffering = false;
          });
          attachCards();
        }, 100);
      }
    });

    window.addEventListener('pagehide', function () {
      document.querySelectorAll('.product-card-video').forEach(function (v) {
        try { v.pause(); } catch (err) {}
      });
    });
  })();

  // ── BACK NAV DETECTION ──
  var isBackNav = false;
  if (window.performance && window.performance.getEntriesByType) {
    var navEntries = window.performance.getEntriesByType('navigation');
    if (navEntries.length && navEntries[0].type === 'back_forward') {
      isBackNav = true;
    }
  }

  // ── CONNECTION QUALITY DETECTION ──
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var isSlowConnection = false;
  if (connection) {
    var slowTypes = ['slow-2g', '2g', '3g'];
    isSlowConnection = slowTypes.indexOf(connection.effectiveType) !== -1;
    connection.addEventListener('change', function () {
      isSlowConnection = slowTypes.indexOf(connection.effectiveType) !== -1;
    });
  }

  // ── LOGO URL ──
  var LOGO_URL = 'https://cdn.shopify.com/s/files/1/0723/2389/1431/files/IMG_2961_438e2d55-49d7-46fc-883c-7e87145af241.png?v=1782759679';

  // ── CSS ──
  if (!document.getElementById('ticedrop-scroll-css')) {
    var scrollStyle = document.createElement('style');
    scrollStyle.id = 'ticedrop-scroll-css';
    scrollStyle.textContent = [
      '.product-grid, .collection-grid, .product-list, [class*="product-grid"], [class*="collection-grid"] {',
      '  -webkit-overflow-scrolling: touch;',
      '  transform: translateZ(0);',
      '  backface-visibility: hidden;',
      '}',
      '.product-block {',
      '  transform: translateZ(0);',
      '  backface-visibility: hidden;',
      '  -webkit-backface-visibility: hidden;',
      '  will-change: transform;',
      '}',
      '.image-cont {',
      '  transform: translateZ(0);',
      '  backface-visibility: hidden;',
      '  -webkit-backface-visibility: hidden;',
      '  isolation: isolate;',
      // Dark background always present — this is what shows instead of white
      '  background: #171717;',
      '}',
      '.product-block__image--primary {',
      '  background: #171717;',
      '}',
      '.product-block__image--primary img:not(.td-logo-loader) {',
      '  transform: translateZ(0);',
      '  backface-visibility: hidden;',
      '  -webkit-backface-visibility: hidden;',
      '  image-rendering: auto;',
      '}'
    ].join('\n');
    document.head.appendChild(scrollStyle);
  }

  if (!document.getElementById('ticedrop-shimmer-css')) {
    var shimmerStyle = document.createElement('style');
    shimmerStyle.id = 'ticedrop-shimmer-css';
    shimmerStyle.textContent = [
      // Back nav — instant, no fade
      'body.back-nav .product-block__image--primary img:not(.td-logo-loader) {',
      '  opacity: 1 !important;',
      '  transition: none !important;',
      '}',
      'body.back-nav .image-cont .product-block__image--primary::before,',
      'body.back-nav .image-cont .product-block__image--primary::after {',
      '  display: none !important;',
      '}',
      'body.back-nav .td-logo-loader { display: none !important; }',

      // Images start visible — dark container background is the placeholder
      // NO opacity:0 on img — this is the key fix for white flash
      '.product-block__image--primary img:not(.td-logo-loader) {',
      '  opacity: 1;',
      '}',

      // Loading state — dark bg + gold shimmer on the wrapper
      '.image-cont:not(.img-loaded) .product-block__image--primary {',
      '  position: relative;',
      '  overflow: hidden;',
      '}',

      // Dark base layer
      '.image-cont:not(.img-loaded) .product-block__image--primary::before {',
      '  content: "";',
      '  position: absolute;',
      '  inset: 0;',
      '  background: #171717;',
      '  z-index: 1;',
      '  pointer-events: none;',
      '}',

      // Gold shimmer sweep
      '.image-cont:not(.img-loaded) .product-block__image--primary::after {',
      '  content: "";',
      '  position: absolute;',
      '  inset: 0;',
      '  background: linear-gradient(',
      '    105deg,',
      '    transparent 20%,',
      '    rgba(201,168,76,0.08) 40%,',
      '    rgba(245,215,142,0.18) 50%,',
      '    rgba(201,168,76,0.08) 60%,',
      '    transparent 80%',
      '  );',
      '  background-size: 250% 100%;',
      '  animation: td-gold-sweep 2s ease-in-out infinite;',
      '  z-index: 3;',
      '  pointer-events: none;',
      '}',

      '@keyframes td-gold-sweep {',
      '  0% { background-position: 250% 0; }',
      '  100% { background-position: -250% 0; }',
      '}',

      // Logo loader
      '.td-logo-loader {',
      '  position: absolute;',
      '  top: 50%;',
      '  left: 50%;',
      '  transform: translate(-50%, -50%);',
      '  z-index: 2;',
      '  width: 70%;',
      '  max-width: 120px;',
      '  opacity: 0;',
      '  animation: td-logo-breathe 2.5s ease-in-out infinite;',
      '  filter: brightness(1.1);',
      '  border-radius: 4px;',
      '  pointer-events: none;',
      '}',

      '@keyframes td-logo-breathe {',
      '  0%   { opacity: 0;    transform: translate(-50%, -50%) scale(0.92); filter: brightness(0.8); }',
      '  30%  { opacity: 0.85; transform: translate(-50%, -50%) scale(1);    filter: brightness(1.1); }',
      '  70%  { opacity: 0.85; transform: translate(-50%, -50%) scale(1);    filter: brightness(1.1); }',
      '  100% { opacity: 0;    transform: translate(-50%, -50%) scale(0.92); filter: brightness(0.8); }',
      '}',

      // Once loaded — remove dark overlay and shimmer
      '.image-cont.img-loaded .product-block__image--primary::before,',
      '.image-cont.img-loaded .product-block__image--primary::after {',
      '  display: none;',
      '}',
      '.image-cont.img-loaded .td-logo-loader {',
      '  display: none;',
      '}'
    ].join('\n');
    document.head.appendChild(shimmerStyle);
  }

  if (isBackNav) {
    document.documentElement.classList.add('back-nav');
    document.addEventListener('DOMContentLoaded', function () {
      document.body.classList.add('back-nav');
    });
  }

  // ── SWEEP — mark already-decoded images immediately ──
  function sweepLoadedImages() {
    document.querySelectorAll('.product-block__image--primary img:not(.td-logo-loader)').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        var cont = img.closest('.image-cont');
        if (cont) cont.classList.add('img-loaded');
      }
    });
  }

  // ── INJECT LOGO INTO LOADING CARDS ──
  function injectLogoLoader(cont) {
    if (cont._logoInjected) return;
    cont._logoInjected = true;
    var imgWrap = cont.querySelector('.product-block__image--primary');
    if (!imgWrap) return;
    var logo = document.createElement('img');
    logo.className = 'td-logo-loader';
    logo.src = LOGO_URL;
    logo.alt = '';
    logo.setAttribute('aria-hidden', 'true');
    imgWrap.appendChild(logo);
  }

  // ── AGGRESSIVE IMAGE PRELOADING ──
  var _preloadCache = {};
  function preloadImage(src) {
    if (!src || _preloadCache[src]) return;
    _preloadCache[src] = true;
    var img = new Image();
    img.decoding = 'async';
    img.src = src;
  }

  function preloadUpcomingImages() {
    var viewportHeight = window.innerHeight;
    var lookahead = isSlowConnection ? viewportHeight * 2 : viewportHeight * 3;
    document.querySelectorAll('.product-block__image--primary img:not(.td-logo-loader)').forEach(function (img) {
      var rect = img.getBoundingClientRect();
      if (rect.top > 0 && rect.top < lookahead) {
        var src = img.currentSrc || img.src;
        if (src) preloadImage(src);
        if (img.srcset) {
          var parts = img.srcset.split(',');
          [parts[0], parts[parts.length - 1]].forEach(function (part) {
            var url = part.trim().split(' ')[0];
            if (url) preloadImage(url);
          });
        }
      }
    });
  }

  // ── IMAGE PRIORITY LOADING ──
  function prioritizeImages() {
    var viewportHeight = window.innerHeight;
    var eagerZone = isSlowConnection ? viewportHeight * 1 : viewportHeight * 2;

    document.querySelectorAll('.product-block__image--primary img:not(.td-logo-loader)').forEach(function (img) {
      var rect = img.getBoundingClientRect();
      if (rect.top < eagerZone) {
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
        img.decoding = 'async';
        if (img.decode) img.decode().catch(function () {});
        if (img.complete && img.naturalWidth > 0) {
          var cont = img.closest('.image-cont');
          if (cont) cont.classList.add('img-loaded');
        }
      }
    });

    preloadUpcomingImages();
  }

  function initImageFade(cont) {
    // Sweep first — if already loaded, mark immediately
    var imgs = cont.querySelectorAll('.product-block__image--primary img:not(.td-logo-loader)');

    if (isBackNav) {
      cont.classList.add('img-loaded');
      return;
    }

    injectLogoLoader(cont);

    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        cont.classList.add('img-loaded');
      } else {
        img.addEventListener('load', function () {
          cont.classList.add('img-loaded');
        }, { once: true });
        img.addEventListener('error', function () {
          cont.classList.add('img-loaded');
        }, { once: true });
      }
    });
  }

  function enforceNativeLazy(cont) {
    if (!isBackNav) {
      cont.querySelectorAll('img:not([loading]):not(.td-logo-loader)').forEach(function (img) {
        var rect = img.getBoundingClientRect();
        if (rect.top > window.innerHeight * 2) {
          img.setAttribute('loading', 'lazy');
        }
      });
    }
    cont.querySelectorAll('video').forEach(function (v) {
      v.setAttribute('preload', 'none');
      v.querySelectorAll('source[src]').forEach(function (s) {
        var dataSrc = s.getAttribute('data-src') || s.getAttribute('src');
        s.setAttribute('data-src', dataSrc);
        s.removeAttribute('src');
      });
    });
  }

  // ── VIDEO SYSTEM ──
  function getSourceData(video) {
    return Array.from(video.querySelectorAll('source[data-src]')).map(function (s) {
      return { src: s.getAttribute('data-src'), type: s.getAttribute('type') };
    });
  }

  function buildFreshVideo(cont) {
    var old = cont.querySelector('.product-card-video');
    if (!old) return null;
    var sources = getSourceData(old);
    if (!sources.length) return null;

    var v = document.createElement('video');
    v.className = 'product-card-video';
    v.muted = true;
    v.loop = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('preload', 'none');
    v.setAttribute('tabindex', '-1');
    v.setAttribute('aria-hidden', 'true');

    sources.forEach(function (s) {
      var el = document.createElement('source');
      el.setAttribute('data-src', s.src);
      el.setAttribute('type', s.type);
      v.appendChild(el);
    });

    old.parentNode.replaceChild(v, old);
    return v;
  }

  function resetCard(cont) {
    clearTimeout(cont._vt);
    clearTimeout(cont._bufferTimeout);
    cont._vt = null;
    cont._bufferTimeout = null;
    cont._playing = false;
    cont._buffering = false;
    var img = cont.querySelector('.product-block__image--primary');
    cont.classList.remove('video-active');
    if (img) img.classList.remove('is-hidden');
    buildFreshVideo(cont);
  }

  function doPlay(cont, video) {
    if (cont._playing) return;
    var img = cont.querySelector('.product-block__image--primary');
    var p = video.play();
    if (p !== undefined) {
      p.then(function () {
        cont._playing = true;
        cont._buffering = false;
        video.classList.add('is-playing');
        cont.classList.add('video-active');
        if (img) img.classList.add('is-hidden');
      }).catch(function () {
        resetCard(cont);
      });
    }
  }

  function startVideo(cont) {
    if (document.visibilityState === 'hidden') return;
    if (cont._playing || cont._buffering) return;

    var primaryImg = cont.querySelector('.product-block__image--primary img:not(.td-logo-loader)');
    if (primaryImg && !primaryImg.complete) {
      primaryImg.addEventListener('load', function () {
        if (cont._vt) startVideo(cont);
      }, { once: true });
      return;
    }

    cont._buffering = true;
    var video = buildFreshVideo(cont);
    if (!video) return;

    video.querySelectorAll('source[data-src]').forEach(function (s) {
      s.setAttribute('src', s.getAttribute('data-src'));
    });
    video.preload = 'auto';
    video.load();

    var played = false;

    function onCanPlayThrough() {
      if (played || !cont._buffering) return;
      played = true;
      clearTimeout(cont._bufferTimeout);
      video.removeEventListener('canplaythrough', onCanPlayThrough);
      video.removeEventListener('error', onError);
      doPlay(cont, video);
    }

    function onError() {
      video.removeEventListener('canplaythrough', onCanPlayThrough);
      video.removeEventListener('error', onError);
      resetCard(cont);
    }

    video.addEventListener('canplaythrough', onCanPlayThrough);
    video.addEventListener('error', onError);

    cont._bufferTimeout = setTimeout(function () {
      if (!played && cont._buffering) {
        played = true;
        video.removeEventListener('canplaythrough', onCanPlayThrough);
        video.removeEventListener('error', onError);
        doPlay(cont, video);
      }
    }, 6000);
  }

  var _observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var cont = entry.target;
      if (entry.isIntersecting) {
        if (document.visibilityState === 'hidden') return;
        clearTimeout(cont._vt);
        cont._vt = setTimeout(function () { startVideo(cont); }, 800);
      } else {
        resetCard(cont);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

  function attachCards() {
    sweepLoadedImages();
    prioritizeImages();
    document.querySelectorAll('.image-cont[data-has-video="true"]').forEach(function (cont) {
      if (cont._videoAttached) return;
      cont._videoAttached = true;
      enforceNativeLazy(cont);
      resetCard(cont);
      initImageFade(cont);
      _observer.observe(cont);
    });
    document.querySelectorAll('.image-cont:not([data-has-video="true"])').forEach(function (cont) {
      if (cont._fadeAttached) return;
      cont._fadeAttached = true;
      enforceNativeLazy(cont);
      initImageFade(cont);
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      document.querySelectorAll('.image-cont[data-has-video="true"]').forEach(function (cont) {
        cont._videoAttached = false;
        cont._playing = false;
        cont._buffering = false;
        _observer.unobserve(cont);
      });
    } else {
      setTimeout(attachCards, 250);
    }
  });

  // Periodic sweep — catches any images that loaded between JS ticks
  setInterval(sweepLoadedImages, 500);

  function init() {
    if (isBackNav) {
      document.querySelectorAll('.image-cont').forEach(function (cont) {
        cont.classList.add('img-loaded');
      });
    }
    sweepLoadedImages();
    prioritizeImages();
    attachCards();
    var grid = document.querySelector('#MainContent, main, .collection-grid, .product-grid');
    if (grid && !grid._videoWatching) {
      grid._videoWatching = true;
      new MutationObserver(function () {
        setTimeout(attachCards, 150);
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 200);
  });

})();


















